const speakersHome = (state = {}, action) => {
    switch (action.type) {
        case 'SPEAKERS_HOME_DATA_LOADED' : 
            return{
            ...state,
            speakersHomeData : action.payload
            }
        default:
            return state
        }
  }
  export default speakersHome